module.exports = __webpack_public_path__ + "img/Mask Group 2925@2x.fa134b7d.png";